module.exports = __webpack_public_path__ + "media/images/flags/1x1/sun-bbc9ba432ec6d257eead74cef8e0f5c1.svg";